import "babel-polyfill"; // Solve IE9
import Vue from "vue";
// import ElementUI from 'element-ui'
// import locale from 'element-ui/lib/locale/lang/en'
// import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(ElementUI)

import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
locale.use(lang)


import App from "./App.vue";
import router from "./router/index";
import store from "./store/index";
import "./element";
import * as filters from "./filtres/index"; // Global filter
import "./role"; // jurisdiction

// import "./mock";




import "./assets/icons/iconfont";
import IconSvg from "./components/common/IconSvg.vue"; // svg
import VueClipboard from 'vue-clipboard2' //copey
// Register replication
Vue.use(VueClipboard)
    // Register global components（register global）
Vue.component("icon-svg", IconSvg);

// Register global utility filters（register global utility filters）.
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false;
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
